const initialState = {
  invoices: [],
  payments:[]
};

const invoiceReducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_INVOICES":
      return {
        ...state,
        invoices: action.payload,
      };
    case "GET_PAYMENTS":
      return {
        ...state,
        payments: action.payload,
      };
    case "GET_INVOICE":
      return {
        ...state,
        invoice: action.payload,
      };
    case "FETCH_CUSTOMERS_INVOICES":
      return {
        ...state,
        customers: action.payload,
      };
    default:
      return { ...state };
  }
};
export default invoiceReducer;
